import { css, MenuItem, Stack, styled } from '@mui/material';
import { CheckIcon } from '@braskai/icons';
import { Button, ButtonProps } from '@braskai/ui-kit';

export const Container = styled(Stack)({
  gap: 20,
});

export const SubmitButton = styled((props: ButtonProps) => <Button size="xl" fullWidth {...props} />)('');

export const BackButton = styled((props: ButtonProps) => <Button size="xl" variant="outlined" {...props} />)(
  ({ theme }) => ({
    '& .MuiButton-startIcon': {
      margin: 0,
    },

    [theme.breakpoints.up('tablet')]: {
      width: '100%',
    },
  }),
);

export const Actions = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: 12,
});

export const Option = styled(MenuItem)({
  '&.MuiButtonBase-root': {
    '&.MuiMenuItem-root': {
      '&.Mui-selected': {
        display: 'flex',
        justifyContent: 'space-between',
      },
    },
  },
});

export const SCheckIcon = styled(CheckIcon)(
  ({ theme }) => css`
    color: ${theme.palette.primary[600]};
  `,
);
